import {useEffect, useState} from 'react'

const QUERY = '(prefers-reduced-motion: no-preference)'

const getInitialState = () => !window.matchMedia(QUERY).matches

/**
 * A custom hook that tells us if the user has opted-out of animations on an
 * operating system level. Checks on initial run and updates if the user changes
 * the setting while on the site.
 *
 * @returns {Boolean} Whether the user prefers reduced motion or not
 *
 * @see [Accessible Animations in React](https://joshwcomeau.com/react/prefers-reduced-motion/)
 */
export default function usePrefersReducedMotion() {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(getInitialState)

  useEffect(() => {
    const mediaQueryList = window.matchMedia(QUERY)

    function handleMediaQueryChange(event) {
      setPrefersReducedMotion(!event.matches)
    }

    mediaQueryList.addListener(handleMediaQueryChange)

    return function unUnmount() {
      mediaQueryList.removeListener(handleMediaQueryChange)
    }
  }, [])

  return prefersReducedMotion
}
